import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

// Deep-link para abrir a ficha de um cliente no CRM (usado em emails de
// alerta, ex.: carrinho abandonado). Faz a impersonação via switchUser e
// redirecciona para /perfil, replicando o comportamento do PersonLink.
export default function ClienteFichaRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { switchUser } = useAuth();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (id) {
        try { await switchUser(Number(id)); } catch { /* noop */ }
      }
      if (!cancelled) navigate('/perfil', { replace: true });
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div
      data-testid="cliente-ficha-redirect"
      className="min-h-[40vh] flex items-center justify-center text-sm text-[#6B7280]"
    >
      A abrir a ficha do cliente…
    </div>
  );
}
